<template>
    <Form ref="formValidate" :label-width="120">
        <FormItem label="操作：">
            <Select :transfer="true" v-model="formItem.select" :label-in-value="true" @on-change="onChangeSelect">
                <OptionGroup label="参数设置">
                    <Option v-for="(value, key) in opType1" :value="JSON.stringify(value)" :key="key">{{key}}</Option>
                </OptionGroup>
                <OptionGroup label="设备控制">
                    <Option v-for="(value, key) in opType2" :value="JSON.stringify(value)" :key="key">{{key}}</Option>
                </OptionGroup>
                <OptionGroup label="使用信息">
                    <Option v-for="(value, key) in opType3" :value="JSON.stringify(value)" :key="key">{{key}}</Option>
                </OptionGroup>
                <OptionGroup label="设备监控">
                    <Option v-for="(value, key) in opType4" :value="JSON.stringify(value)" :key="key">{{key}}</Option>
                </OptionGroup>
            </Select>
        </FormItem>
        <FormItem label="设备检索条件：">
            <Select v-model="formItem.selectCondition" @on-change="changeCondition">
                <Option value="meterId">设备编号（生产）</Option>
            </Select>
        </FormItem>
        <FormItem label=" 输入检索条件：">
            <Input v-model="formItem.inputMeterId" @on-change.stop="changeMeterId" placeholder="请输入设备编号"></Input>
        </FormItem>
    </Form>
</template>
<script>
    export default {
        created() {
            this.request();
        },
        data() {
            return {
                showSelectMeterType: false,
                showAddressData: false,
                showInputIdCard: false,
                showInputMeterId: false,
                addressDataSelect: "",
                meterTypeData: [],
                addressData: [],
                formItem: {
                    input: "",
                    select: "",
                    selectName: "",
                    selectCondition: "meterId",
                    radio: "male",
                    checkbox: [],
                    switch: true,
                    date: "",
                    time: "",
                    slider: [20, 50],
                    textarea: ""
                },
                opType: global.commandop,
                opType1: global.commandopProduce1,
                opType2: global.commandopProduce2,
                opType3: global.commandopProduce3,
                opType4: global.commandopProduce4,
            };
        },
        methods: {
            handleSubmit(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        this.$Message.success("Success!");
                    } else {
                        this.$Message.error("Fail!");
                    }
                });
            },
            handleReset(name) {
                this.$refs[name].resetFields();
            },
            changeCondition() {
                this.showSelectMeterType = false;
                this.showAddressData = false;
                this.showInputIdCard = false;
                this.showInputMeterId = false;
                this.formItem.selectMeterType = null;
                this.addressDataSelect = null;
                this.formItem.inputIdCard = null;
                this.formItem.inputMeterId = null;
                switch (this.formItem.selectCondition) {
                    case "meterId":
                        this.showInputMeterId = true;
                        break;
                    case "idCard":
                        this.showInputIdCard = true;
                        break;
                    case "meterType":
                        this.showSelectMeterType = true;
                        break;
                    case "address":
                        this.showAddressData = true;
                        break;
                }
                this.$emit("listenToChild1NextEvent", this.checkNext());
            },
            choiceAll(data) {
                if (data.length > 0) {
                    this.addressDataSelect = data[data.length - 1].toString(); //当复选框选中时则会打印出选中的内容
                } else {
                    this.addressDataSelect = null;
                }
                this.$emit("listenToChild1NextEvent", this.checkNext());
            },
            changeIdCard() {
                this.$emit("listenToChild1NextEvent", this.checkNext());
            },
            changeMeterId() {
                this.$emit("listenToChild1NextEvent", this.checkNext());
            },
            changeMeterType() {
                this.$emit("listenToChild1NextEvent", this.checkNext());
            },
            onChangeSelect(param) {
                this.$emit("listenToChild1SelectEvent", param);

                this.$emit("listenToChild1NextEvent", this.checkNext());
            },
            checkNext() {
                if (this.formItem.select != null && this.formItem.select != "" &&
                    this.formItem.selectCondition != null && this.formItem.selectCondition != "" &&
                    ((this.formItem.selectMeterType != null && this.formItem.selectMeterType != "") ||
                        (this.formItem.inputIdCard != null && this.formItem.inputIdCard != "") ||
                        (this.formItem.inputMeterId != null && this.formItem.inputMeterId != "") ||
                        (this.addressDataSelect != null && this.addressDataSelect != ""))) {
                    return true;
                } else {
                    return false;
                }
            },
            request() {
                var that = this;
                $.ajax({
                    url: "/api/getAddressTree",
                    contentType: "application/json",
                    type: "get",
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }

                        that.addressData = data.body[0].children;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });

                $.ajax({
                    url: "/api/getMeterTypeInfo",
                    contentType: "application/json",
                    type: "get",
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }

                        that.meterTypeData = data.body.resultList;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            }
        }
    };
</script>
